
class AnimationDondeEstamos {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleDondeEstamos = this.sectionsContainer.querySelectorAll('.pagina-donde-estamos');
		
		if (!this.$moduleDondeEstamos.length)
			return;
		
		this.$moduleDondeEstamosElements = [];

		this.$moduleDondeEstamos.forEach(module => {
			this.$moduleDondeEstamosElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleDondeEstamos.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleDondeEstamosElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleDondeEstamos = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleDondeEstamos[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleDondeEstamosElements[index], { clearProps: true });
			}
        });
    
        this.moduleDondeEstamos.addLabel('step1');
        this.moduleDondeEstamos.to(this.$moduleDondeEstamos[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleDondeEstamos.to(this.$moduleDondeEstamosElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationDondeEstamos;
